import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'https://api.rinkalhealthcare.com/api';

const apiClient = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const getServices = () => apiClient.get('/services/');
export const getServiceById = (id) => apiClient.get(`/services/${id}/`);

export const createAppointment = (data) => apiClient.post('/appointments/', data);
export const getAppointments = () => apiClient.get('/appointments/');

export const createInquiry = (data) => apiClient.post('/inquiries/', data);
export const getInquiries = () => apiClient.get('/inquiries/');

export const getTestimonials = () => apiClient.get('/testimonials/');

export const getNews = () => apiClient.get('/news/');

export default apiClient;
